import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';
import { BanksService } from '../bank-management/banks.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  Contacts: any;
  entities: any=[];
  distibutorName: any;
  emp_mobile: string;
  disPhoneNumber: any;

  constructor( private toast: ToastrService,
    private loader: NgxUiLoaderService,
    private service: AuthService,
    private ngxload: NgxUiLoaderService,
    private bankService: BanksService,
   ) { }

  ngOnInit(): void {
    this.getContactUsDetails();
    this.userDistributorTreeApi();
    this.emp_mobile=localStorage.getItem('emp_mobile');
   
  }
  getContactUsDetails(){
    this.ngxload.start();
this.service.getContactUsDetails().subscribe((res:any)=>{
  this.ngxload.stop();

  this.Contacts=res.object;
  
},err=>{
  this.ngxload.stop();

})
  }
  userDistributorTreeApi(){
    this.ngxload.start();

    this.bankService.userDistributorTree().subscribe((res: any) => {
      this.entities.push(res.object);
      this.distibutorName=this.entities[0].l1.distibutorName
      this.disPhoneNumber=this.entities[0].l1.phoneNumber
      this.ngxload.stop();

    },err=>{
      this.ngxload.stop();

    })
  }
}
